module.exports = __webpack_public_path__ + "static/media/iconfinder_pdf-01_3079281.ab597c07.png";